import { render, staticRenderFns } from "./RetirementFactors.vue?vue&type=template&id=64d25734"
import script from "./RetirementFactors.vue?vue&type=script&lang=js"
export * from "./RetirementFactors.vue?vue&type=script&lang=js"
import style0 from "./RetirementFactors.vue?vue&type=style&index=0&id=64d25734&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../ChatGenial-hom-sync/client/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports